<template>
  <BasePageContent>
    <BasePageHeader
      class="px-3"
      sectiontitle=""
      :title="title"
      :description="description"
    >
      <ul class="nk-block-tools g-1">
        <li class="nk-block-tools-opt">
          <a
            href="#"
            title="Record payment"
            class="btn btn-white btn-dim btn-outline-light"
            @click.prevent
          >
            <em class="icon ni ni-plus"></em>
            <span class="d-none d-md-inline">Record payment</span>
            <em class="dd-indc w3-text-theme icon ni ni-chevron-right"></em>
          </a>
        </li>
      </ul>
    </BasePageHeader>
    <div class="card-inner">
      <div class="px-1">Feature under construction</div>
    </div>
  </BasePageContent>
</template>
<script>
import { ref } from "vue";
export default {
  setup() {
    const title = ref("Transactions");
    const title_singular = ref("payment");
    const description = ref("View all your transactions");
    return {
      title,
      title_singular,
      description,
    };
  },
};
</script>